import "./DeleteAllNotification.css";

export default function DeleteAllNotification({
  setShowDeletePopup,
  handleClearAll,
  notificationLength,
}) {
  console.log("notificationLength", notificationLength);

  return (
    <>
      <div className="notification_popup_overlay">
        <div className="notification_popup_box">
          <h3>Clear all notifications?</h3>
          <p>This action cannot be undone.</p>

          <div className="notification_popup_actions">
            <button
              className="notification_cancel_btn"
              onClick={() => setShowDeletePopup(false)}
            >
              Cancel
            </button>

            <button
              disabled={notificationLength === 0}
              className="notification_delete_btn"
              onClick={() => {
                handleClearAll();
                setShowDeletePopup(false);
              }}
            >
              Clear All
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
